import { Injectable } from '@angular/core';
import { uploadData, getUrl, remove } from '@aws-amplify/storage';

@Injectable({ providedIn: 'root' })
export class FileService {

  async uploadFiles(files: File[],folder: 'commentImage' | 'timeEntryImage',parentId: string): Promise<string[]> {
    const paths: string[] = [];
    for (const file of files) {
      const s3Path = `${folder}/${parentId}/${Date.now()}_${file.name}`;
      try {
        const operation = uploadData({
          path: s3Path,
          data: file,
          options: { contentType: file.type }
        });
        await operation.result;
        paths.push(s3Path);
      } catch (error) {
        console.error(`Error upload ${file.name}:`, error);
      }
    }
    return paths;
  }

  async getFileUrl(path: string | null | undefined): Promise<string> {
    if (!path) return '';
    try {
      const result = await getUrl({ path });
      return result.url.toString();
    } catch (error) {
      console.error(`Error GetUrl ${path}:`, error);
      return '';
    }
  }

  async deleteFile(path: string): Promise<void> {
    try {
      await remove({ path });
    } catch (error) {
      console.error(`Error deleting ${path}`, error);
    }
  }
}
